import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";

export default function TextFieldDateValidationComponent({
  propsData,
  name,
  onChildDataChange,
}) {
  const { handleChange, values } = propsData;

  const sendDataToParent = (event) => {
    handleChange(event);
    onChildDataChange(event.target.value);
  };

  return (
    <Box
      component="form"
      sx={{
        "& .MuiTextField-root": { width: "100%" },
      }}
      noValidate
      autoComplete="off"
    >
      <TextField
        type="date"
        onChange={sendDataToParent}
        value={values[name]}
        name={name}
      />
    </Box>
  );
}
